import { listShow, listClick } from '@/pages/Home/firebase'
import Exposure from '@/utils/exposure'

export default {
  data() {
    return {
      isTracked: false,
    }
  },
  watch: {
    datas: {
      handler(val) {
        if (!this.isTracked && val && val.length > 0) {
          setTimeout(() => {
            // 这么写是因为 gtag 在 onload 事件中加载出来之后，埋点才会成功上报
            this.$nextTick(
              () => (this.trackHomeListShow(), (this.isTracked = true))
            )
          }, 1000)
        }
      },
      immediate: true,
    },
  },
  methods: {
    goDetail(item, index) {
      const { id, game, displayArea } = item
      listClick({
        list_position: index + 1,
        list_id: id,
        list_cp_name: game,
        list_tab: displayArea,
      })
      this.$emit('click', item, 'list')
    },
    trackHomeListShow() {
      const targets = document.querySelectorAll(
        `.banner-item-container.visible.${this.type}`
      )
      const exposure = new Exposure()
      const datas = this.datas
      exposure.observer({
        threshold: 0.5, //交叉比例, 默认为1
        exposureType: 'once', // 曝光类型，反复曝光repeat / 单次曝光once, 默认单次曝光
        ele: targets, // 要监测的元素，可以是单个元素，也可以是nodelist
        callback: (ele) => {
          // 回调
          const index = ele.getAttribute('data-index')
          const item = datas[index]
          const { id, game, displayArea } = item
          listShow({
            list_position: index * 1 + 1,
            list_id: id,
            list_cp_name: game,
            list_tab: displayArea,
          })
        },
      })
    },
  },
}
